import konRobot from "../../assets/images/logo/kon_robot.svg";
import delOb from "../../assets/images/logo/delob.svg";
import "./partnersBlock.css";

const partners = [
  { logo: konRobot, name: "Консорциум Робототехники", url: "" },
  { logo: delOb, name: "Деловое объединение кластеров России", url: "" },
];

export default function PartnersBlock() {
  return (
    <div className="container">
      <div className="partnersContent">
        <h3 className="title">Партнеры</h3>
        <div className="partnersBlock">
          {partners.map((partner) => {
            const content = (
              <div className="partnersBlock-item">
                <img src={partner.logo} alt={partner.name} />
              </div>
            );

            if (partner.url) {
              return (
                <a
                  key={partner.name}
                  href={partner.url}
                  target="_blank"
                  rel="noreferrer"
                  className="partnersBlock-link"
                >
                  {content}
                </a>
              );
            }

            return (
              <div key={partner.name} className="partnersBlock-link">
                {content}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
